import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import {
  Typography,
  IconButton,
  Button,
  CircularProgress,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

const CompleteReminderDialog = ({
  open,
  onClose,
  onSubmit,
  reminder,
  loading,
}) => {
  const [actionPoint, setActionPoint] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (reminder) {
      setActionPoint(reminder.action_point || "");
      setError("");
    }
  }, [reminder]);

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (
          reason &&
          (reason === "backdropClick" || reason === "escapeKeyDown")
        )
          return;
        onClose();
      }}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Complete Reminder
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Please provide an <strong>Action Point</strong> before marking this
          reminder as completed.
        </Typography>
        <Mui.TextField
          label="Action Point"
          fullWidth
          multiline
          minRows={2}
          value={actionPoint}
          onChange={(e) => {
            setActionPoint(e.target.value);
            if (e.target.value.trim()) setError("");
          }}
          error={Boolean(error)}
          helperText={error}
        />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#84DEB8",
            color: "#000",
            "&:hover": { backgroundColor: "#6cc9a1" },
          }}
          disabled={loading}
          onClick={() => {
            if (!actionPoint.trim()) {
              setError("Action point is required!");
              return;
            }
            onSubmit(reminder.id, actionPoint);
            onClose();
          }}
        >
          {loading ? <CircularProgress size={20} /> : "Complete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompleteReminderDialog;
